import { PixiViewportSystem } from 'yage/systems/render/PixiViewport';
import { LOCAL } from '../services/local.js';

/**
 * Phones drop a hidden tab's WebGL context. Pixi asks for it back, but the browser may never return it, leaving a blank
 * canvas while the game keeps running (only the HTML boards stay). When the page is visible again and the context is
 * still lost, ask once more; if that fails too, `recover` runs (solo: save and reload into the game).
 */
export function watchGraphicsContext(recover: () => void, waitMs = 2500) {
    let timer = 0;
    const renderer = () => LOCAL.model?.getSystem(PixiViewportSystem)?.pixiApp?.renderer as unknown as { gl?: WebGLRenderingContext; context?: { extensions?: { loseContext?: { restoreContext(): void } } } } | undefined;
    const lost = () => !!renderer()?.gl?.isContextLost();
    const check = () => {
        if (document.hidden || timer || !lost()) return;
        try { renderer()?.context?.extensions?.loseContext?.restoreContext(); } catch { /* the browser restores on its own, or not at all */ }
        timer = window.setTimeout(() => { timer = 0; if (!document.hidden && lost()) recover(); }, waitMs);
    };
    document.addEventListener('visibilitychange', check);
    window.addEventListener('pageshow', check);
    window.addEventListener('focus', check);
    document.querySelector('canvas.pixi-canvas')?.addEventListener('webglcontextlost', () => window.setTimeout(check, 0));
}

const RESUME = 'sky-harbor:resume-solo';
/** Reload straight back into the solo game, skipping the start menu once. */
export function reloadIntoGame() { try { sessionStorage.setItem(RESUME, '1'); } catch { /* the start menu still offers Continue */ } location.reload(); }
export function resumeRequested(): boolean {
    try { const want = sessionStorage.getItem(RESUME) === '1'; sessionStorage.removeItem(RESUME); return want; } catch { return false; }
}
